let googleMapsScriptPromise = null;

const fetchGoogleMapsApiKey = async () => {
  const response = await fetch('/.netlify/functions/get-google-maps-api-key');

  if (!response.ok) {
    throw new Error('Unable to load Google Maps API key.');
  }

  const data = await response.json();

  if (!data.apiKey) {
    throw new Error('Google Maps API key is not available.');
  }

  return data.apiKey;
};

const injectGoogleMapsScript = (apiKey) => {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('Google Maps can only be loaded in the browser.'));
      return;
    }

    const existingScript = document.querySelector('script[data-google-maps]');

    if (existingScript) {
      if (window.google && window.google.maps && window.google.maps.places) {
        resolve(window.google);
      } else {
        existingScript.addEventListener('load', () => resolve(window.google));
        existingScript.addEventListener('error', () => reject(new Error('Failed to load Google Maps script.')));
      }
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.dataset.googleMaps = 'true';
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error('Failed to load Google Maps script.'));

    document.head.appendChild(script);
  });
};

export const loadGoogleMapsScript = async () => {
  if (typeof window === 'undefined') {
    throw new Error('Google Maps can only be loaded in the browser.');
  }

  if (window.google && window.google.maps && window.google.maps.places) {
    return window.google;
  }

  if (!googleMapsScriptPromise) {
    googleMapsScriptPromise = (async () => {
      const apiKey = await fetchGoogleMapsApiKey();
      await injectGoogleMapsScript(apiKey);
      return window.google;
    })();
  }

  try {
    return await googleMapsScriptPromise;
  } catch (error) {
    googleMapsScriptPromise = null;
    throw error;
  }
};
